webpackJsonp([129236653009385],{

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdKeyboardArrowLeft = function MdKeyboardArrowLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.7 26.8l-2.3 2.3-10-10 10-10 2.3 2.4-7.7 7.6z' })
	        )
	    );
	};
	
	exports.default = MdKeyboardArrowLeft;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdKeyboardArrowRight = function MdKeyboardArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 27.3l7.7-7.7-7.7-7.7 2.3-2.3 10 10-10 10z' })
	        )
	    );
	};
	
	exports.default = MdKeyboardArrowRight;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _accessTime = __webpack_require__(38);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _label = __webpack_require__(40);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _folder = __webpack_require__(39);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _gatsbyImage = __webpack_require__(36);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _PostIcons = __webpack_require__(28);
	
	var _PostIcons2 = _interopRequireDefault(_PostIcons);
	
	var _typography = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_Component) {
	    _inherits(Post, _Component);
	
	    function Post() {
	        _classCallCheck(this, Post);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Post.prototype.removeEntities = function removeEntities(str) {
	        return str.replace(/&[^;]+;/g, " ");
	    };
	
	    Post.prototype.render = function render() {
	        var node = this.props.node;
	        return Glamor.createElement(
	            "div",
	            {
	                css: {
	                    border: "1px solid rgb(240,240,240)",
	                    borderRadius: "4px",
	                    boxShadow: "0 1px 4px rgb(240,240,240)",
	                    margin: "" + (0, _typography.rhythm)(0.5),
	                    transition: "all 0.2s ease",
	                    position: "relative",
	                    width: "100%",
	                    "@media screen and (min-width: 780px)": {
	                        maxWidth: "calc(50% - " + (0, _typography.rhythm)(2) + ")",
	                        width: "calc(50% - " + (0, _typography.rhythm)(2) + ")",
	                        margin: (0, _typography.rhythm)(1),
	                        ":hover": {
	                            boxShadow: "0px 2px 15px rgb(220,220,220)",
	                            transition: "all 0.5s ease"
	                        }
	                    },
	                    "@media screen and (min-width: 1281px)": {
	                        maxWidth: "calc(33.33% - " + (0, _typography.rhythm)(2) + ")",
	                        width: "calc(33.33% - " + (0, _typography.rhythm)(2) + ")"
	                    }
	                },
	                key: node.slug
	            },
	            Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: "/" + node.slug, css: { textDecoration: "none", ":hover": { textDecoration: "none" } } },
	                node.featured_media && Glamor.createElement(_gatsbyImage2.default, { css: { borderRadius: "4px 4px 0 0", maxHeight: 200, minHeight: 200 }, sizes: node.featured_media.localFile.childImageSharp.sizes }),
	                Glamor.createElement("div", { css: { background: "linear-gradient(rgba(255,255,255,0) 50%,rgba(255,255,255,1) 95%)", width: "100%", height: 200, position: "absolute", top: 0, left: 0 } }),
	                Glamor.createElement(
	                    "h5",
	                    { css: { padding: "1em 1em 0", marginBottom: ".8rem", marginTop: "-2em", color: "rgb(133,133,133)", position: "relative" } },
	                    this.removeEntities(node.title)
	                )
	            ),
	            Glamor.createElement(
	                "div",
	                { css: { padding: "0 1em 0.5em" } },
	                Glamor.createElement("div", {
	                    css: {
	                        color: "rgb(180,180,180)",
	                        display: "block",
	                        textOverflow: "ellipsis",
	                        wordWrap: "break-word",
	                        overflow: "hidden",
	                        maxHeight: 50,
	                        marginBottom: "1.5em",
	                        fontSize: 14,
	                        position: "relative"
	                    },
	                    dangerouslySetInnerHTML: { __html: node.excerpt }
	                }),
	                Glamor.createElement(_PostIcons2.default, { css: { display: "flex", flexWrap: "wrap" }, node: node })
	            )
	        );
	    };
	
	    return Post;
	}(_react.Component);
	
	exports.default = Post;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _accessTime = __webpack_require__(38);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _label = __webpack_require__(40);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _folder = __webpack_require__(39);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _gatsbyImage = __webpack_require__(36);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _glamor = __webpack_require__(17);
	
	var _PostIcons = __webpack_require__(28);
	
	var _PostIcons2 = _interopRequireDefault(_PostIcons);
	
	var _typography = __webpack_require__(11);
	
	var _Post = __webpack_require__(57);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavLink = function NavLink(props) {
	  if (!props.test) {
	    return Glamor.createElement(
	      _gatsbyLink2.default,
	      { to: props.url },
	      props.text
	    );
	  } else {
	    return Glamor.createElement(
	      "span",
	      null,
	      props.text
	    );
	  }
	};
	
	var card = (0, _glamor.css)({
	  margin: "0 auto",
	
	  "& .link-more": {
	    display: "none"
	  },
	  "@media screen and (min-width: 750px)": {
	    maxWidth: 800
	  },
	  "@media screen and (min-width: 1281px)": {
	    maxWidth: 1280
	  },
	  '& .date-field': {
	    display: "none !important"
	  },
	  '& .category-field': {
	    marginBottom: (0, _typography.rhythm)(0.5)
	  }
	});
	
	var PostsList = function (_Component) {
	  _inherits(PostsList, _Component);
	
	  function PostsList() {
	    _classCallCheck(this, PostsList);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostsList.prototype.render = function render() {
	    var posts = this.props.posts;
	    return Glamor.createElement(
	      "div",
	      _extends({
	        css: {
	          display: "flex",
	          flexWrap: "wrap",
	          padding: (0, _typography.rhythm)(3 / 4)
	        }
	      }, card),
	      posts.map(function (post) {
	        return Glamor.createElement(_Post2.default, { key: post.node.title, node: post.node });
	      })
	    );
	  };
	
	  return PostsList;
	}(_react.Component);
	
	exports.default = PostsList;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(71);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostsList = __webpack_require__(58);
	
	var _PostsList2 = _interopRequireDefault(_PostsList);
	
	var _glamor = __webpack_require__(17);
	
	var _keyboardArrowLeft = __webpack_require__(72);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(73);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavLink = function NavLink(props) {
	  if (!props.page) {
	    return Glamor.createElement(
	      _gatsbyLink2.default,
	      { to: props.url },
	      props.text,
	      " ",
	      props.children
	    );
	  } else {
	    return Glamor.createElement(
	      "span",
	      null,
	      props.text
	    );
	  }
	};
	
	var tagPageTitle = (0, _glamor.css)({
	  "@media screen and (min-width:790px)": {
	    display: "none"
	  },
	  "@media screen and (max-width:789px)": {
	    fontSize: "18px",
	    backgroundColor: "rgb(226, 226, 226)",
	    textAlign: "center",
	    color: "rgb(107, 107, 107)",
	    padding: "1em 0"
	  }
	});
	
	var pageNavWrapper = (0, _glamor.css)({
	  margin: "1em auto 3em",
	  flexDirection: "columm",
	  justifyContent: "center",
	  display: "flex",
	
	  "@media screen and (min-width:790px)": {
	    flexDirection: "row",
	    textAlign: "center"
	  },
	  "& .previousLink a, & .nextLink a": {
	    margin: ".5em",
	    backgroundColor: "rgb(133, 133, 133)",
	    padding: ".25em .5em",
	    borderRadius: "50px",
	    color: "rgb(255,255,255)",
	    textDecoration: "none",
	    textTransform: "uppercase",
	    display: "flex",
	    alignItems: "center",
	    border: "1px solid rgb(133, 133, 133)",
	    fontSize: "14px",
	    width: "10em",
	    //justifyContent: `center`,
	    position: "relative",
	    transition: "all .3s linear",
	
	    "&:hover": {
	      transition: "all .3s linear",
	      backgroundColor: "rgb(255,255,255)",
	      color: "rgb(133, 133, 133)",
	
	      "& svg": {
	        backgroundColor: "rgb(133, 133, 133)",
	        color: "rgb(255,255,255)"
	      }
	    }
	  },
	  "& .nextLink a": {
	    paddingLeft: "1em",
	
	    "& svg": {
	      display: "flex",
	      justifyContent: "center",
	      position: "absolute",
	      alignItems: "center",
	      right: "0.5em",
	      top: "20%",
	      transition: "all .3s linear"
	    }
	  },
	  "& .previousLink a": {
	    flexDirection: "row-reverse",
	    paddingRight: "1em",
	
	    "& svg": {
	      display: "flex",
	      justifyContent: "center",
	      position: "absolute",
	      alignItems: "center",
	      left: "0.5em",
	      top: "20%"
	    }
	  },
	  "& svg": {
	    backgroundColor: "rgb(255,255,255)",
	    color: "rgb(133, 133, 133)",
	    borderRadius: 50
	  }
	});
	
	var Tag = function (_Component) {
	  _inherits(Tag, _Component);
	
	  function Tag() {
	    _classCallCheck(this, Tag);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Tag.prototype.render = function render() {
	    var pathContext = this.props.pathContext;
	    var tagPath = pathContext.pathPrefix;
	    var postEdges = this.props.data.allWordpressPost.edges;
	
	    var group = pathContext.group,
	        index = pathContext.index,
	        first = pathContext.first,
	        last = pathContext.last,
	        pageCount = pathContext.pageCount;
	
	
	    var groupPosts = group.map(function (_ref) {
	      var node = _ref.node;
	
	      return postEdges.find(function (edge) {
	        return edge.node.id === node.id;
	      });
	    });
	
	    var previousUrl = "/" + tagPath + "/" + (index - 1 == 1 ? "" : index - 1);
	    var nextUrl = "/" + tagPath + "/" + (index + 1);
	    var tagName = group[0] && group[0].currentTag;
	
	    return Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement("h1", _extends({}, tagPageTitle, { dangerouslySetInnerHTML: { __html: tagName } })),
	      Glamor.createElement(_PostsList2.default, { posts: groupPosts }),
	      Glamor.createElement(
	        "div",
	        pageNavWrapper,
	        index > 1 && Glamor.createElement(
	          "div",
	          { className: "previousLink" },
	          Glamor.createElement(
	            NavLink,
	            { page: first, url: previousUrl, text: "Previous" },
	            Glamor.createElement(_keyboardArrowLeft2.default, { size: "18px" })
	          )
	        ),
	        last < 1 && Glamor.createElement(
	          "div",
	          { className: "nextLink" },
	          Glamor.createElement(
	            NavLink,
	            { page: last, url: nextUrl, text: "Next" },
	            Glamor.createElement(_keyboardArrowRight2.default, { size: "18px" })
	          )
	        )
	      )
	    );
	  };
	
	  return Tag;
	}(_react.Component);
	
	exports.default = Tag;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-js-29117863f2491320cb1f.js